<template>
  <div>
    <!-- head -->
    <div class="flex justify-between items-center p-2">
      <h5 style="line-height: 40px">
        <i class="dot" style="width: 8px; height: 8px"></i>
        {{ title }}
      </h5>
      <div v-if="!isPrint && !readonly">
        <vs-button color="secondary" @click="addRow">{{ $t('항목추가') }}</vs-button>
        <vs-button
          color="secondary"
          type="border"
          class="ml-2"
          @click="deleteRow"
        >{{ $t('선택삭제') }}</vs-button>
      </div>
    </div>
    <table>
      <colgroup>
        <col v-if="!isPrint && !readonly" width="4%" />
        <col
          v-for="infoH in infoHeader.length + 3"
          :key="infoH"
          :width="`${96 / (infoHeader.length + 3)}%`"
        />
      </colgroup>
      <thead>
        <tr>
          <th v-if="!isPrint && !readonly" class="select-none">
            <div class="flex justify-center items-center w-full">
              <vs-checkbox
                v-model="allCheck"
                @click.native="onClickAllCheckBox"
              />
            </div>
          </th>
          <th v-for="infoH in infoHeader" :key="infoH">{{ infoH }}</th>
          <th>{{ $t('전일누계') }}</th>
          <th>{{ $t('금일') }}</th>
          <th>{{ $t('누계') }}</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="item in list" :key="item.id">
          <td v-if="!isPrint && !readonly" class="select-none">
            <div class="flex justify-center items-center w-full">
              <vs-checkbox
                v-if="!item.readonly"
                v-model="checkData"
                :vs-value="item.id"
              />
            </div>
          </td>
          <td v-for="infoH in infoHeader" :key="infoH">
            <p v-if="isPrint" class="print-input my-1">{{ item[infoH] }}</p>
            <ml-input
              v-else
              rows="1"
              class="w-full flex-1 p-1"
              placeholder="입력"
              :readonly="item.readonly"
              v-model.lazy="item[infoH]"
            />
          </td>
          <td>
            <p v-if="isPrint" class="print-input my-1">{{ item.yesterday }}</p>
            <comma-input
              v-else
              readonly
              class="w-full flex-1 p-1"
              :placeholder="colPlaceholders[0]"
              v-model.lazy="item.yesterday"
            />
          </td>
          <td>
            <p v-if="isPrint" class="print-input my-1">{{ item.today }}</p>
            <comma-input
              v-else
              class="w-full flex-1 p-1"
              :placeholder="colPlaceholders[1]"
              v-model.lazy="item.today"
              @input="rowTotal(item)"
            />
          </td>
          <td>
            <p v-if="isPrint" class="print-input my-1">{{ item.total }}</p>
            <comma-input
              v-else
              readonly
              class="w-full flex-1 p-1"
              :placeholder="colPlaceholders[2]"
              v-model.lazy="item.total"
            />
          </td>
        </tr>
      </tbody>
      <!-- 계  -->
      <tbody>
        <tr>
          <td
            :colspan="
              !isPrint && !readonly ? 1 + infoHeader.length : infoHeader.length
            "
            style="background: #f9f9f9"
            class="text-center"
          >{{ $t('계') }}</td>
          <td>
            <p v-if="isPrint" class="print-input my-1">
              {{ allYesterday | comma }}
            </p>
            <CommaInput
              v-else
              class="w-full flex-1 p-1"
              :placeholder="totalPlaceholders[0]"
              :value="allYesterday"
              readonly
            />
          </td>
          <td>
            <p v-if="isPrint" class="print-input my-1">{{ allToday | comma }}</p>
            <CommaInput
              v-else
              class="w-full flex-1 p-1"
              :placeholder="totalPlaceholders[1]"
              :value="allToday"
              readonly
            />
          </td>
          <td>
            <p v-if="isPrint" class="print-input my-1">{{ total | comma }}</p>
            <CommaInput
              v-else
              class="w-full flex-1 p-1"
              :placeholder="totalPlaceholders[2]"
              readonly
              :value="total"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { nextTick } from "vue";
export default {
  props: {
    title: String,
    isPrint: Boolean,
    infoHeader: Array,
    value: Array,
    colPlaceholders: {
      type: Array,
      default: () => ["", "", ""],
    },
    totalPlaceholders: {
      type: Array,
      default: () => ["", "", ""],
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  filters: {
    comma(str) {
      return `${str}`.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  data() {
    return {
      list: this.value,
      allCheck: false,
      checkData: [],
    };
  },
  computed: {
    allYesterday() {
      const _yd = this.list.reduce((prev, data) => {
        if (!!data.yesterday) return prev + Number(data.yesterday);
        else return prev;
      }, 0);
      return _yd;
    },
    allToday() {
      const _td = this.list.reduce((prev, data) => {
        if (!!data.today) return prev + Number(data.today);
        else return prev;
      }, 0);
      return _td;
    },
    total() {
      const _tt = this.list.reduce((prev, data) => {
        if (!!data.total) return prev + Number(data.total);
        else return prev;
      }, 0);
      return _tt;
    },
  },
  watch: {
    value: {
      handler(value) {
        this.list = value;
      },
    },
    list: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    // 항목추가
    addRow() {
      this.list.push({ id: this.generateRandomString(6) });
      this.allCheck = false;
    },
    // 선택삭제
    deleteRow() {
      this.list = this.list.filter((item) => {
        if (item.readonly) return true;
        return !this.checkData.includes(item.id);
      });

      this.allCheck = false;
      this.checkData = [];
    },
    rowTotal(item) {
      if (item.yesterday)
        item.total = Number(item.yesterday) + Number(item.today);
      else item.total = Number(item.today);
    },
    onClickAllCheckBox() {
      setTimeout(() => {
        if (this.allCheck) this.checkData = this.list.map((item) => item.id);
        else this.checkData = [];
      }, 100);
    },
    generateRandomString(num) {
      const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
      let result = "";
      const charactersLength = characters.length;
      for (let i = 0; i < num; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  width: 100%;

  text-align: left;
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;

  border-collapse: collapse;
  margin-bottom: 28px;

  thead {
    th {
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      line-height: 17px;

      background: #f9f9f9;
      border: solid #cdcdcd 1px;
      padding: 16px 6px;
    }
  }
  tbody {
    tr {
      td {
        font-size: 14px;
        font-weight: 500;
        line-height: 17px;
        border: solid #cdcdcd 1px;
      }
    }
  }
}
</style>
